// `redux-state-sync` used to mirror every dispatched action into localStorage
// under this key so other tabs could replay it. It has been removed, but the
// key it left behind is still sitting in every existing user's browser --
// potentially several MB of a single serialised UPDATE_KEYFRAME action, which
// counts against the ~5MB localStorage quota that redux-persist needs. Nothing
// else will ever clean it up, so do it once on startup.
const LEGACY_ACTION_SYNC_KEY = "LAST_ACTION";

export function dropStaleActionSyncKey() {
	try {
		localStorage.removeItem(LEGACY_ACTION_SYNC_KEY);
	} catch (e) {
		// localStorage unavailable (private mode, blocked cookies) -- nothing to clean.
	}
}
